import { getAnimationDuration } from "./data/utils";

var $ = window.$;

window.whenJqueryLoaded(function () {
	$ = window.$;
});

function paddles($elems) {
    // duration of scroll animation
    var scrollDuration = 300;
    // paddles
    var leftPaddle = $elems.leftPaddle;
    var rightPaddle = $elems.rightPaddle;

    // get some relevant size for the paddle triggering point
    var paddleMargin = 0.1;
    
    // get wrapper width
    var getMenuWrapperSize = function () {
        return $elems.container.outerWidth();
    }
    var menuWrapperSize = getMenuWrapperSize();
    // the wrapper is responsive
    $(window).on('resize', function () {
        menuWrapperSize = getMenuWrapperSize();
    });
    
    // get items dimensions
    var getItemsLength = function () {
    	return $elems.icon.length;
    };
    var getItemSize = function () {
    	return $($elems.slider).outerWidth(true);
    };
    // get total width of all menu items
    var getMenuSize = function () {
        return getItemsLength() * getItemSize();
    };
    // get how much of menu is invisible
    var menuInvisibleSize = getMenuSize() - menuWrapperSize;
    
    // get how much have we scrolled to the left
    var getMenuPosition = function () {
        return $($elems.slider).scrollLeft();
    };
    
    // finally, what happens when we are actually scrolling the menu
    $($elems.slider).scroll(function () {
        // get how much of menu is invisible
        menuInvisibleSize = getMenuSize() - menuWrapperSize;
        // get how much have we scrolled so far
        var menuPosition = getMenuPosition();
    
        var menuEndOffset = menuInvisibleSize - paddleMargin;
    
        // show & hide the paddles 
        // depending on scroll position
        if (menuPosition <= paddleMargin) {
            $(leftPaddle).addClass('d-none');
            $(rightPaddle).removeClass('d-none');
        } else if (menuPosition < menuEndOffset) {
            // show both paddles in the middle
            $(leftPaddle).removeClass('d-none');
            $(rightPaddle).removeClass('d-none');
        } else if (menuPosition >= menuEndOffset) {
            $(leftPaddle).removeClass('d-none');
            $(rightPaddle).addClass('d-none');
        }
    });
    
    // scroll to left
    $(document).off('click', rightPaddle); //To avoid firing handler multiple times
    $(document).on('click', rightPaddle , function () {
    	$($elems.slider).animate({
            scrollLeft: '+=400'
        }, scrollDuration);
    });
    
    // scroll to right
    $(document).off('click', leftPaddle); //To avoid firing handler multiple times
    $(document).on('click', leftPaddle , function () {
    	$($elems.slider).animate({
            scrollLeft: '-=400'
        }, scrollDuration);
    });
}

function dragElement(elmnt) {
    var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
    const header = elmnt.closest('#'+elmnt.id + "header");
    //if (document.getElementById(elmnt.id + "header")) {
    if(header){
        /* if present, the header is where you move the DIV from:*/
        document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    } else {
        /* otherwise, move the DIV from anywhere inside the DIV:*/
        elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }
}

function initMatchBoxPaddles() {
    const elems = {
        icon: $('.box-slider-partite'),
        slider: '.slider-box-partite',
        container: $('.container-slider-box-partite'),
        leftPaddle: '.left-paddle-box-partite',
        rightPaddle: '.right-paddle-box-partite'
    };
    paddles(elems);
}

function initEvColonneLayout() {
    $(document).on('click','#ev-una-colonna', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.colonne-evento-live').addClass("unaColonna");
        $('.colonne-evento-live').removeClass("dueColonne treColonne");
        $(this).addClass("selezionato-toolbox");
        $('#ev-due-colonne, #ev-tre-colonne').removeClass("selezionato-toolbox");
    });
    
    $(document).on('click','#ev-due-colonne', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.colonne-evento-live').addClass("dueColonne");
        $('.colonne-evento-live').removeClass("unaColonna treColonne");
        $(this).addClass("selezionato-toolbox");
        $('#ev-una-colonna, #ev-tre-colonne').removeClass("selezionato-toolbox");
    });
    
    $(document).on('click','#ev-tre-colonne', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.colonne-evento-live').addClass("treColonne");
        $('.colonne-evento-live').removeClass("unaColonna dueColonne");
        $(this).addClass("selezionato-toolbox");
        $('#ev-una-colonna, #ev-due-colonne').removeClass("selezionato-toolbox");
    });
}

function initManualScrolling() {
    // scroller con mano 
    
    const orizzontaleSscroller = '.horiz-sc';
    let isDown = false;
    let startX;
    let scrollLeft;
    
    $(document).on('mousedown', orizzontaleSscroller, function (e) {
    	isDown = true;
        this.classList.add('scrollando');
        startX = e.pageX - this.offsetLeft;
        scrollLeft = this.scrollLeft;
    });
    
    $(document).on('mouseleave', orizzontaleSscroller, function () {
    	isDown = false;
    	this.classList.remove('scrollando');
    });
    
    $(document).on('mouseup', orizzontaleSscroller, function (e) {
    	 isDown = false;
    	 this.classList.remove('scrollando');
    });
    
    $(document).on('mousemove', orizzontaleSscroller, function (e) {
    	if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.offsetLeft;
        const walk = (x - startX) * 2; //scroll-fast
        this.scrollLeft = scrollLeft - walk;
    });
}

export function initBetslipEffects() {
    $(document).on('click','.tasto-stringi-dx',function () {
        $('.body-sport').addClass("e-largo-dx");
    });
    
    $(document).on('click','.mostra-sidebar-dx, .testo-mostra-sidebar-dx',function () {
        $('.body-sport').removeClass("e-largo-dx");
    });
    
    $(document).on('click','#allarga-coupon',function () {
        $('#sidebar-dx').toggleClass("allarga-sidebar-dx");
    });
}

export function initLiveSectionEffects() {
    initEvColonneLayout();
}

export function initLiveMatchEffects() {
    $('.f-sidebarSX').click(function () {
        $('#sidebar-sx').toggleClass("stringi");
    });
    
    initEvColonneLayout();
    
    $(document).on('click','.apri-widget-evento-dx',function () {
        $(".griglia-centrale-sport").toggleClass('aperto-widget-evento-dx');
        $(".griglia-centrale-sport").removeClass('aperto-widget-evento-su');
    });
    
    $(document).on('click','.apri-widget-evento-su',function () {
        $(".griglia-centrale-sport").toggleClass('aperto-widget-evento-su');
        $(".griglia-centrale-sport").removeClass('aperto-widget-evento-dx');
    });
}

export function initMultiLiveEffects() {
	initMatchBoxPaddles();
    initManualScrolling();
    
    $(document).on('click','.apri-trascinabile',function () {
        $(this).closest('.box-multilive').find('#trascinabile').removeClass("d-none").addClass("d-flex");
        dragElement( $(this).closest('.box-multilive').find('#trascinabile').get(0)); 
    });
    
    $(document).on('click','.chiudiTrascinabile',function () {
    	$(this).closest("#trascinabile").removeClass("d-flex").addClass("d-none");
    });
}

export function highlightOddChange(oldValue, newValue, classList) {
    if (classList) {
		if (newValue == null) {
			classList.remove('quota-aumentata');
			classList.remove('quota-diminuita');
		} else if (oldValue != null && oldValue !== newValue) {
			if (newValue > oldValue) {
				classList.remove('quota-diminuita');
				if (!classList.contains('quota-aumentata')) {
					classList.add('quota-aumentata');
				}              
			} else {
				classList.remove('quota-aumentata');
				if (!classList.contains('quota-diminuita')) {
					classList.add('quota-diminuita');
				} 
			}
            const timeout = getAnimationDuration();
            let t = setTimeout(() => {
                classList.remove('quota-aumentata');
                classList.remove('quota-diminuita');
                clearTimeout(t)
            }, timeout);
		}
    }
}
